import * as gtm3Map from '@/constants/gtm'
import * as gtm4Map from '@/constants/gtm4'
import { analyticsFactory } from '@accor/customer-vue-services'
import TagManager from '@accor/core-services/dist/gtm'

TagManager.initDefaultAutoTracking()

export const { getGtmId, trackPage, trackEventByGtmMap, trackEvent, trackingDirective } =
  analyticsFactory({ gtm3Map, gtm4Map })
